"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_rainbow_components_1 = require("react-rainbow-components");
var styled_1 = require("./styled");
function Loading() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_1.Row, null,
            react_1.default.createElement(styled_1.InfoLoadingContainer, null,
                react_1.default.createElement(styled_1.FlightTitleLoading, null,
                    react_1.default.createElement(react_rainbow_components_1.LoadingShape, null)),
                react_1.default.createElement(styled_1.FlightDateLoading, null,
                    react_1.default.createElement(react_rainbow_components_1.LoadingShape, null))),
            react_1.default.createElement(styled_1.StyledPlanePath, null),
            react_1.default.createElement(styled_1.InfoLoadingContainer, null,
                react_1.default.createElement(styled_1.FlightTitleLoading, null,
                    react_1.default.createElement(react_rainbow_components_1.LoadingShape, null)),
                react_1.default.createElement(styled_1.FlightDateLoading, null,
                    react_1.default.createElement(react_rainbow_components_1.LoadingShape, null)))),
        react_1.default.createElement(styled_1.LoadingFooter, null,
            react_1.default.createElement(styled_1.OutputLoading, null,
                react_1.default.createElement(styled_1.OutputLabelLoading, null,
                    react_1.default.createElement(react_rainbow_components_1.LoadingShape, null)),
                react_1.default.createElement(styled_1.OutputValueLoading, null,
                    react_1.default.createElement(react_rainbow_components_1.LoadingShape, null))),
            react_1.default.createElement(styled_1.OutputLoading, null,
                react_1.default.createElement(styled_1.OutputLabelLoadingLarge, null,
                    react_1.default.createElement(react_rainbow_components_1.LoadingShape, null)),
                react_1.default.createElement(styled_1.OutputValueLoadingLarge, null,
                    react_1.default.createElement(react_rainbow_components_1.LoadingShape, null))),
            react_1.default.createElement(styled_1.OutputLoading, null,
                react_1.default.createElement(styled_1.OutputLabelLoading, null,
                    react_1.default.createElement(react_rainbow_components_1.LoadingShape, null)),
                react_1.default.createElement(styled_1.OutputValueLoading, null,
                    react_1.default.createElement(react_rainbow_components_1.LoadingShape, null))))));
}
exports.default = Loading;
//# sourceMappingURL=loading.js.map